const chatLauncher = document.querySelector('.ftrchaticon')
chatLauncher.addEventListener('click', (e) => {

    e.preventDefault()
    e.stopImmediatePropagation()

    const chatElement = document.querySelector('#shopify-chat')
    const chatShadowHost = chatElement.querySelector('inbox-online-store-chat');
    if (chatShadowHost) {
        chatElement.classList.add('active')
        const shadowRoot = chatShadowHost.shadowRoot;
        const button = shadowRoot.querySelector('button');
        button.click()
    }
}, true);

// old code
// document.addEventListener('DOMContentLoaded', function() {
//     let mobileNavTrigger = document.querySelector('.mobile-nav-trigger');
//     let addCartIcons = document.querySelectorAll('.js-quick-add-form');
//     let cartListClose = document.querySelector('.modal__close--cart');
//     let cartListOpen = document.getElementById('HeaderCartTrigger');
//     let cartListModal = document.getElementById('HeaderCart');
//     let cartAdd = document.querySelector('.add-to-cart');
//     let toobarTop = document.querySelector('.toolbar');
//     let isOpen = false;

//     mobileNavTrigger.addEventListener('click', function() {
//         isOpen = !isOpen;
//         let chatTidio = document.getElementById('tidio-chat');
//         let cardsDiv = document.querySelector('.yotpo-widget-clear');
      
//         if (isOpen) {
//             cardsDiv.style.display = 'none';
//             toobarTop.style.display = 'none';
//             chatTidio.style.opacity = '0';
//         } else {
//             cardsDiv.style.display = 'block';
//             toobarTop.style.display = 'block';
//             chatTidio.style.opacity = '1';
//         }
//     });

//     cartListClose.addEventListener('click', function() {
//       cartListModal.classList.remove('is-active');
//       document.documentElement.classList.remove('cart-open');
//     });

//     addCartIcons.forEach(function(addCartIcon) {
//         addCartIcon.addEventListener('click', function() {
//             cardsDiv.style.display = 'none';
//         });
//     });

//     cartAdd.addEventListener('click', function() {
//         isOpen = !isOpen;
//         let chatTidio = document.getElementById('tidio-chat');
//         let cardsDiv = document.querySelector('.yotpo-widget-clear');
      
//         if (isOpen) {
//             cardsDiv.style.display = 'none';
//             toobarTop.style.display = 'none';
//             chatTidio.style.opacity = '0';
//         } else {
//             cardsDiv.style.display = 'block';
//             toobarTop.style.display = 'block';
//             chatTidio.style.opacity = '1';
//         }
//     });
// });

// new code
document.addEventListener('DOMContentLoaded', function() {
    let mobileNavTrigger = document.querySelector('.mobile-nav-trigger');
    let addCartIcons = document.querySelectorAll('.js-quick-add-form');
    let cartListClose = document.querySelector('.modal__close--cart');
    let cartListOpen = document.getElementById('HeaderCartTrigger');
    let cartListModal = document.getElementById('HeaderCart');
    let cartAdd = document.querySelector('.add-to-cart');
    let toolbarTop = document.querySelector('.toolbar');
    let isOpen = false;

    mobileNavTrigger.addEventListener('click', function() {
        isOpen = !isOpen;
        let cardsDiv = document.querySelector('.yotpo-widget-clear');
      
        if (cardsDiv) {
            cardsDiv.style.display = isOpen ? 'none' : 'block';
        }

        if (toolbarTop) {
            toolbarTop.style.display = isOpen ? 'none' : 'block';
        }
    });

    if (cartListClose) {
        cartListClose.addEventListener('click', function() {
            cartListModal.classList.remove('is-active');
            document.documentElement.classList.remove('cart-open');
        });
    }

    addCartIcons.forEach(function(addCartIcon) {
        addCartIcon.addEventListener('click', function() {
            let cardsDiv = document.querySelector('.yotpo-widget-clear');
            if (cardsDiv) {
                cardsDiv.style.display = 'none';
            }
        });
    });

    if (cartAdd) {
        cartAdd.addEventListener('click', function() {
            isOpen = !isOpen;
            let cardsDiv = document.querySelector('.yotpo-widget-clear');
          
            if (cardsDiv) {
                cardsDiv.style.display = isOpen ? 'none' : 'block';
            }

            if (toolbarTop) {
                toolbarTop.style.display = isOpen ? 'none' : 'block';
            }
        });
    }
});



  document.addEventListener("DOMContentLoaded", function () {
    var shippingElement = document.querySelector(".money.conversion-bear-money.hungry");

    if (!shippingElement) return;

    var currentHost = window.location.host;

    if (currentHost === "amour.hu") {
      // Update for Hungary
      shippingElement.textContent = "20,000 Ft";
      shippingElement.setAttribute("data-amount", "20000");
    } 
  });

// ==============================
// COLLECTION SLIDER – assign banner color classes based on metafield text
// ==============================
(function () {
  function classifyType(el) {
    if (!el) return;
    var textSpan = el.querySelector('span.metafield-single_line_text_field');
    var text = (textSpan ? textSpan.textContent : el.textContent || '').trim().toLowerCase();
    el.classList.remove('label--women', 'label--men', 'label--unisex', 'label--default');
    if (text.indexOf('ženski parfum') !== -1 || text.indexOf('zenski parfum') !== -1) {
      el.classList.add('label--women');
    } else if (text.indexOf('moški parfum') !== -1 || text.indexOf('moski parfum') !== -1 || text.indexOf("men's perfumes") !== -1) {
      el.classList.add('label--men');
    } else if (text.indexOf('unisex parfum') !== -1 || text.indexOf('unisex perfumes') !== -1) {
      el.classList.add('label--unisex');
    } else {
      el.classList.add('label--default');
    }
  }

  function applyLabels(root) {
    (root || document).querySelectorAll('.slfe-collection-slider .grid-item .grid-item__content .main-grid-name.fggfg').forEach(classifyType);
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', function () { applyLabels(); });
  // In case of late-loaded slider content
  window.addEventListener('load', function () { applyLabels(); });

  // Observe dynamic changes
  var slider = document.querySelector('.slfe-collection-slider');
  if (slider && 'MutationObserver' in window) {
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) { if (m.addedNodes && m.addedNodes.length) applyLabels(slider); });
    });
    obs.observe(slider, { childList: true, subtree: true });
  }
})();

// ==============================
// FEATURED COLLECTION – stabilize slick layout after init/resize/image load
// ==============================
(function () {
  var $ = window.jQuery || window.$;
  if (!$) return;

  // Mark sliders as ready only after a stable setPosition
  function markReady($s){
    try {
      if($s && $s.length){ $s.addClass('amour-ready'); }
    } catch(e){}
  }

  // Reveal immediately; add a hidden placeholder for ratings to avoid layout shift
  function ensureRatingsThenReady($s){
    try{ ensureRatingsPlaceholder($s); }catch(e){}
    markReady($s);
  }

  function ensureRatingsPlaceholder($s){
    try{
      var slider = $s && $s[0] ? $s[0] : null; if(!slider) return;
      var cards = slider.querySelectorAll('.slick-slide .grid-item'); if(!cards.length) return;
      for(var i=0;i<cards.length;i++){
        var card = cards[i];
        if(card.querySelector('.jdgm-widget.jdgm-preview-badge')) continue;
        if(card.querySelector('.jdgm--placeholder')) continue;
        var ph = document.createElement('div');
        ph.className = 'jdgm-widget jdgm-preview-badge jdgm--placeholder';
        ph.style.minHeight = '17px';
        ph.style.lineHeight = '17px';
        ph.style.visibility = 'hidden';
        var before = card.querySelector('.loyalty_preview.gg');
        if(before && before.parentNode){ before.parentNode.insertBefore(ph, before); continue; }
        var after = card.querySelector('.main-grid-value2');
        if(after && after.parentNode){ after.parentNode.insertBefore(ph, after.nextSibling); continue; }
        var meta = card.querySelector('.grid-item__meta-main');
        if(meta){ meta.insertBefore(ph, meta.firstChild); }
        else { card.appendChild(ph); }
      }
    }catch(e){}
  }

  // After Slick init events – add amour-ready once layout is stabilized
  $(document).on('init reInit setPosition afterChange', '.slfe-collection-slider', function(e){
    var $s = $(this);
    if ($s.hasClass('slick-initialized')) {
      requestAnimationFrame(function(){ ensureRatingsThenReady($s); });
    }
  });

  // Apply same handling for Featured Collections slider
  $(document).on('init reInit setPosition afterChange', '.slfe-collections-slider', function(){
    var $s = $(this);
    if ($s.hasClass('slick-initialized')) requestAnimationFrame(function(){ ensureRatingsThenReady($s); });
  });

  // Recently viewed – apply same ready gating to avoid card count jump
  $(document).on('init reInit setPosition afterChange', '.recently-viewed, [id$="__recently-viewed"] .slfe-collection-slider', function(){
    var $s = $(this);
    if ($s.hasClass('slick-initialized')) {
      requestAnimationFrame(function(){
        ensureRatingsThenReady($s);
        try { $s.closest('[id$="__recently-viewed"]').addClass('amour-ready'); } catch(e){}
      });
    }
  });

  // Recommendations – quick mark ready on init to avoid initial 3→4 flash
  $(document).on('init', '[id$="__recommendations"] .slfe-collection-slider', function(){
    try {
      var $s = $(this);
      $s.addClass('amour-ready');
      $s.closest('[id$="__recommendations"]').addClass('amour-ready');
    } catch(e){}
  });

  // Po dinamicnem nalaganju priporočil označi kot ready
  document.addEventListener('recommendations:loaded', function(){
    try{
      var $ = window.jQuery || window.$; if(!$) return;
      var $grid = $('product-recommendations .new-grid');
      // Ce je slick že inicializiran, takoj dodaj ready; sicer počakaj na init
      if ($grid.hasClass('slick-initialized')) {
        $grid.addClass('amour-ready');
      } else {
        $grid.one('init', function(){ $(this).addClass('amour-ready'); });
      }
    }catch(e){}
  });

  // Fallback: ensure featured collections become visible even if init events were missed
  document.addEventListener('DOMContentLoaded', function(){
    try{
      var $ = window.jQuery || window.$; if(!$) return;
      var $sc = $('.slfe-collections-slider');
      if($sc.length){ setTimeout(function(){ $sc.addClass('amour-ready'); }, 300); }
      var $rv = $('.recently-viewed');
      if($rv.length){ setTimeout(function(){ $rv.addClass('amour-ready'); }, 300); }
      var $rvSections = $('[id$="__recently-viewed"]');
      if($rvSections.length){ setTimeout(function(){ $rvSections.addClass('amour-ready'); }, 300); }
    }catch(e){}
  });

  // Improve LCP: make visible slide images eager/high priority, others lazy
  function optimizeVisibleImages($s){
    try{
      if(!$s || !$s.length) return;
      var slider = $s[0];
      var activeImgs = slider.querySelectorAll('.slick-slide.slick-active img');
      var allImgs = slider.querySelectorAll('img');
      for(var i=0;i<allImgs.length;i++){
        allImgs[i].setAttribute('loading','lazy');
        allImgs[i].removeAttribute('fetchpriority');
        allImgs[i].setAttribute('decoding','async');
      }
      for(var j=0;j<activeImgs.length;j++){
        activeImgs[j].setAttribute('loading','eager');
        activeImgs[j].setAttribute('fetchpriority','high');
        activeImgs[j].setAttribute('decoding','async');
      }
    }catch(e){}
  }

  $(document).on('init reInit afterChange', '.slfe-collection-slider', function(){
    var $s = $(this);
    if ($s.hasClass('slick-initialized')) optimizeVisibleImages($s);
  });

  $(document).on('init reInit afterChange', '.slfe-collections-slider', function(){
    var $s = $(this);
    if ($s.hasClass('slick-initialized')) optimizeVisibleImages($s);
  });

  $(document).on('init reInit afterChange', '.recently-viewed', function(){
    var $s = $(this);
    if ($s.hasClass('slick-initialized')) optimizeVisibleImages($s);
  });

  // .new-grid sliderji (recommendations, recently-viewed, more-products)
  $(document).on('init reInit setPosition afterChange', '.new-grid', function(){
   var $s = $(this);
    if ($s.hasClass('slick-initialized')) {
      requestAnimationFrame(function(){
        $s.addClass('amour-ready');
        optimizeVisibleImages($s);
      });
    }
 });

  // Recently viewed – ob init označi tudi wrapper in poravnaj pozicije
  $(document).on('init reInit setPosition afterChange', '.recently-viewed.new-grid', function(){
    var $s = $(this);
    if ($s.hasClass('slick-initialized')) {
      requestAnimationFrame(function(){
        $s.addClass('amour-ready');
        try { $s.closest('[id$="__recently-viewed"]').addClass('amour-ready'); } catch(e){}
        try { $s.slick('setPosition'); } catch(e){}
        optimizeVisibleImages($s);
      });
    }
  });

  // Safety: oznaci amour-ready tudi, ce init event zamudimo
  setTimeout(function(){
    try{
      var $ = window.jQuery || window.$; if(!$) return;
      $('.new-grid.slick-initialized').addClass('amour-ready');
    }catch(e){}
  }, 800);

  function setPositionSafe() {
    try {
      var $sliders = $('.slfe-collection-slider, .slfe-collections-slider, .recently-viewed');
      if (!$sliders.length) return;
      $sliders.each(function () {
        var $s = $(this);
        if ($s.hasClass('slick-initialized')) {
          $s.slick('setPosition');
          // ensure visible after forced setPosition, waiting for ratings if any
          ensureRatingsThenReady($s);
          optimizeVisibleImages($s);
        }
      });
    } catch (e) {
      // no-op
    }
  }

  // On window load and resize
  $(window).on('load resize orientationchange', setPositionSafe);

  // When Shopify dynamically (re)loads sections
  document.addEventListener('shopify:section:load', setPositionSafe);
  document.addEventListener('shopify:section:unload', setPositionSafe);

  // When images inside slider finish loading (late)
  document.addEventListener('DOMContentLoaded', function () {
    var slider = document.querySelector('.slfe-collection-slider');
    if (!slider) return;
    var imgs = slider.querySelectorAll('img');
    var pending = imgs.length;
    if (!pending) return setPositionSafe();
    imgs.forEach(function (img) {
      if (img.complete) { if (--pending === 0) setPositionSafe(); return; }
      img.addEventListener('load', function () { if (--pending === 0) setPositionSafe(); });
      img.addEventListener('error', function () { if (--pending === 0) setPositionSafe(); });
    });
  });
})();

// ==============================
// TITLES – fit `.grid-product__title.rrr` to one line by shrinking font-size
// ==============================
(function(){
  function debounce(fn, wait){ var t; return function(){ var ctx=this, args=arguments; clearTimeout(t); t=setTimeout(function(){ fn.apply(ctx, args); }, wait); }; }

  function fitTitle(el){
    try{
      if(!el) return;
      // Ensure single-line layout (CSS already enforces, but double down)
      el.style.whiteSpace = 'nowrap';
      // Start from computed (or stored) base size
      var cs = window.getComputedStyle(el);
      var base = parseFloat(el.dataset.fsBase || cs.fontSize || 12);
      if(!isFinite(base) || base <= 0) base = 12;
      el.dataset.fsBase = String(base);
      var minPx = 8;           // minimal readable size
      var step = 0.5;          // shrink step in px
      el.style.fontSize = base + 'px';
      // If not laid out yet, skip (will retry on next tick)
      if(!el.offsetParent) return;
      var guard = 0;
      // Reduce until it fits or min reached
      while(el.scrollWidth > el.clientWidth && base > minPx && guard < 80){
        base -= step;
        el.style.fontSize = base + 'px';
        guard++;
      }
    }catch(e){}
  }

  function fitTitles(scope){
    try{
      var root = scope && scope.querySelectorAll ? scope : document;
      var nodes = root.querySelectorAll('.grid-product__title.rrr');
      if(!nodes || !nodes.length) return;
      for(var i=0;i<nodes.length;i++) fitTitle(nodes[i]);
    }catch(e){}
  }

  var queued = false;
  function scheduleFit(scope){
    if(queued) return; queued = true;
    requestAnimationFrame(function(){ queued = false; fitTitles(scope); });
  }

  document.addEventListener('DOMContentLoaded', function(){ scheduleFit(); });
  window.addEventListener('load', function(){ scheduleFit(); });
  window.addEventListener('resize', debounce(function(){ scheduleFit(); }, 120));

  // React to Shopify section loads
  document.addEventListener('shopify:section:load', function(e){ scheduleFit(e.target); });

  // React to recommendations load
  document.addEventListener('recommendations:loaded', function(){ scheduleFit(); });

  // React to Slick lifecycle events
  (function(){
    var $ = window.jQuery || window.$; if(!$) return;
    $(document).on('init reInit setPosition afterChange', '.slfe-collection-slider, .slfe-collections-slider, .recently-viewed, .new-grid', function(){ scheduleFit(this); });
  })();
})();

// ==============================
// FEATURED COLLECTION – equalize card heights across slides
// ==============================
(function(){
  var $ = window.jQuery || window.$; if(!$) return;
  function equalize(){
    try{
      var $sliders = $('.slfe-collection-slider'); if(!$sliders.length) return;
      $sliders.each(function(){
        var $s = $(this);
        var $cards = $s.find('.slick-slide .grid-item'); if(!$cards.length) return;
        $cards.css('height','auto');
        var maxH = 0;
        $cards.each(function(){ var h = Math.ceil(this.getBoundingClientRect().height); if(h>maxH) maxH=h; });
        if(maxH>0){ $cards.css('height', maxH + 'px'); }
      });
    }catch(e){}
  }
  $(window).on('load', equalize);
  var t; $(window).on('resize', function(){ clearTimeout(t); t=setTimeout(equalize,120); });
  $(document).on('init reInit setPosition afterChange', '.slfe-collection-slider', equalize);
})();

// ==============================
// JDGM – normalize preview badge structure across all cards
// ==============================
(function(){
  function ensureInnerPrevBadge(widget){
    if (!widget) return;
    if (widget.querySelector('.jdgm-prev-badge')) return;
    var badge = document.createElement('div');
    badge.className = 'jdgm-prev-badge jdgm--empty';
    badge.style.display = 'none';
    widget.appendChild(badge);
  }

  function normalizeJdgm(root){
    try{
      var scope = root || document;
      var widgets = scope.querySelectorAll('.jdgm-widget.jdgm-preview-badge');
      if (!widgets || !widgets.length) return;
      for (var i=0;i<widgets.length;i++) ensureInnerPrevBadge(widgets[i]);
      // also reserve space for hidden widgets in sliders
      reserveBadgeSpace(scope);
    }catch(e){}
  }

  function reserveBadgeSpace(root){
    try{
      var scope = root || document;
      var nodes = scope.querySelectorAll('.slfe-collection-slider .jdgm-widget.jdgm-preview-badge, .slfe-collections-slider .jdgm-widget.jdgm-preview-badge, .grid-item .jdgm-widget.jdgm-preview-badge');
      if(!nodes || !nodes.length) return;
      for (var i=0;i<nodes.length;i++){
        var w = nodes[i];
        try{
          var cs = window.getComputedStyle(w);
          if (cs && cs.display === 'none') { w.style.display = 'block'; }
          w.style.minHeight = '17px';
          w.style.lineHeight = '17px';
        }catch(e){}
      }
    }catch(e){}
  }

  document.addEventListener('DOMContentLoaded', function(){ normalizeJdgm(document); reserveBadgeSpace(document); });
  window.addEventListener('load', function(){ normalizeJdgm(document); reserveBadgeSpace(document); });

  if ('MutationObserver' in window){
    var obs = new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){
        var m = muts[i];
        if (m.addedNodes && m.addedNodes.length){
          for (var j=0;j<m.addedNodes.length;j++){
            var node = m.addedNodes[j];
            if (!(node instanceof HTMLElement)) continue;
            if (node.matches && node.matches('.jdgm-widget.jdgm-preview-badge')) ensureInnerPrevBadge(node);
            normalizeJdgm(node);
            reserveBadgeSpace(node);
          }
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Judge.me ready hook (if present)
  try{ document.addEventListener('jdgm.ready', function(){ normalizeJdgm(document); reserveBadgeSpace(document); }); }catch(e){}
})();

  // Prednostno naloži prve slike v sliderju (LCP)
  function prioritizeFirstImages($scope){
    try{
      var root = $scope && $scope.length ? $scope[0] : ($scope || document);
      var imgs = root.querySelectorAll('.slick-slide img, .grid-item img');
      var count = 0;
      for (var i=0;i<imgs.length;i++){
        var img = imgs[i];
        if (!img) continue;
        // ignoriraj placeholderje
        if (img.hasAttribute('data-src') || img.classList.contains('lazyload')){
          // vseeno dvignemo prioriteto vidnih
        }
        img.setAttribute('loading','eager');
        img.setAttribute('fetchpriority','high');
        img.setAttribute('decoding','async');
        count++;
        if (count >= 4) break; // dovolj za prvi viewport
      }
    }catch(e){}
  }

  // Zgodaj po DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function(){
    try{
      var $ = window.jQuery || window.$; if(!$) return;
      prioritizeFirstImages($('.slfe-collection-slider').first());
      prioritizeFirstImages($('.slfe-collections-slider').first());
      prioritizeFirstImages($('.recently-viewed').first());
      prioritizeFirstImages($('.new-grid').first());
    }catch(e){}
  });

  // Po dinamičnem nalaganju priporočil: prioriteta slik pred slick init
  document.addEventListener('recommendations:loaded', function(e){
    try{
      var $ = window.jQuery || window.$; if(!$) return;
      var $grid = $('product-recommendations .new-grid');
      prioritizeFirstImages($grid);
    }catch(ex){}
  });

  // Product page sticky: set header-aware offset only
  document.addEventListener('DOMContentLoaded', function(){
    try{
      var header = document.getElementById('SiteHeader');
      var headerH = header ? header.offsetHeight : 20;
      document.documentElement.style.setProperty('--sticky-product-top', (headerH) + 'px');
      window.addEventListener('resize', function(){ headerH = header ? header.offsetHeight : 20; document.documentElement.style.setProperty('--sticky-product-top', (headerH) + 'px'); });
    }catch(e){}
  });


